import { Grid } from "@material-ui/core";
import React, { FC } from "react";
import PropertyCard from "./PropertyCard";
import {Property} from "../../../../models/Property";
import {useSelector} from "../../../../redux/store";
import {getCompanies} from "../../../../selectors";
import {getCompanyNameById, getTextByCurrentLanguage} from "../../../../utils/functions";

type PropsType = {
  properties: Array<Property>
}

const PropertiesWrapper: FC<PropsType> = ({ properties }) => {
  const companies = useSelector<any>(getCompanies)

  return (
    <Grid container spacing={6}>
      {properties.map((property, index) => {
        return (
          <Grid item md={4} sm={6} xs={12} lg={3} key={index}>
            <PropertyCard
              id={property.id}
              name={getTextByCurrentLanguage(property.name)}
              createdAt={property.created_at}
              published={property.published}
              general_image={property.general_image_thumbnails.medium}
              companyName={getCompanyNameById(companies, property.company)}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}

export default PropertiesWrapper
